import stencilReduxGlobalScript from '/builds/auvious/ui/genesys-widget/node_modules/@stencil/redux/dist/collection/global/store.js';
import auviousGlobalScript from '/builds/auvious/ui/genesys-widget/src/global/app.ts';
export const globalScripts = () => {
  return Promise.all([
    auviousGlobalScript(),
    stencilReduxGlobalScript(),
  ]);
};
